// Carousel event-box 4 state Frame3 — Swiper 8 (global từ libraryMainsite) với effect fade.
// Mỗi state là 1 slide phủ trọn khung carousel; con của slide vẫn định vị tuyệt đối theo toạ độ
// design vì slide có kích thước 100%x100% ⇒ gốc toạ độ trùng gốc .carousel.
// Nút prev/next dùng đúng 2 sprite có sẵn (F3-asset / F3-asset-2) qua module navigation của Swiper.
window.addEventListener("load", function () {
	if (typeof Swiper === "undefined") return;

	function initCarousel(rootSelector, nextSelector, prevSelector) {
		var root = document.querySelector(rootSelector);
		if (!root) return null;
		var swiper = new Swiper(rootSelector, {
			effect: "fade",
			// crossFade: slide cũ mờ đi cùng lúc slide mới hiện lên — không bị lóe nền giữa 2 state
			fadeEffect: { crossFade: true },
			speed: 600,
			loop: true,
			// text trong slide dài, cho kéo tay trên mobile nhưng không chặn chọn chữ
			allowTouchMove: true,
		});
		// Tự bind 2 nút thay vì dùng module navigation: 2 nút nằm NGOÀI container .carousel nên
		// uniqueNavElements của Swiper tìm trong container không thấy → click không ăn.
		function bind(selector, fn) {
			var btn = document.querySelector(selector);
			if (!btn) return;
			btn.addEventListener("click", function (e) {
				e.preventDefault();
				fn();
			});
		}
		bind(nextSelector, function () {
			swiper.slideNext();
		});
		bind(prevSelector, function () {
			swiper.slidePrev();
		});
		return swiper;
	}

	initCarousel("#Frame3 .carousel.MS__pc", "#Frame3 .next.MS__pc", "#Frame3 .prev.MS__pc");
	initCarousel("#Frame3 .carousel.MS__mb", "#Frame3 .next.MS__mb", "#Frame3 .prev.MS__mb");
});
